import styled from "styled-components";
import wave from "../../assets/waves.svg";
// import apii_logo from '../../assets/apiii_logo.svg';
// import apii_logo_2 from '../../assets//host-record-svgrepo-com.svg'
// import logo_1 from '../../assets//page-analysis-svgrepo-com.svg'
// import logo_3 from '../../assets//cloud-backup-svgrepo-com.svg'
const AboutSection = styled.section`
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Waves = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: -1rem;
`;
const Hand = styled.div`
  position: absolute;
  bottom: -1rem;
  right: 0;

  @media only Screen and (max-width: 40em) {
    display: none;
  }
`;

const Main = styled.div`
  margin: 0 15rem;
  margin-top: 15rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media only Screen and (max-width: 64em) {
    margin: 0 calc(5rem + 5vw);
    margin-top: 10rem;
  }
  @media only Screen and (max-width: 40em) {
    align-items: center;
    margin: 3rem calc(3rem + 3vw);
  }
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-top: 2rem;
`;

const CurvedLine = styled.div`
  width: 7rem;
  height: 2rem;
  border: solid 5px var(--purple);
  border-color: var(--purple) transparent transparent transparent;
  border-radius: 150%/60px 70px 0 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only Screen and (max-width: 40em) {
    flex-direction: column;
  }
`;

const Rocket = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 20%;
  padding-bottom: 5rem;
  animation: 2.5s ease infinite;
  @media only Screen and (max-width: 40em) {
    width: 50vw;
    padding-bottom: 0;
  }
`;

const Cloud = styled.div`
display: flex;
justify-content: center;
align-content: center;
width: 20%;
padding-bottom: 5rem;
animation: 2.5s ease infinite;
@media only Screen and (max-width: 40em) {
  width: 50vw;
  padding-bottom: 0;
}
`;

const API = styled.div`
display: flex;
justify-content: center;
align-content: left;
width: 20%;
margin-top: 1rem;
padding-bottom: 5rem;
@media only Screen and (max-width: 40em) {
  width: 50vw;
  padding-bottom: 0;
}
`;

const DataChart = styled.div`
display: flex;
justify-content: center;
align-content: left;
width: 20%;
padding-bottom: 5rem;
animation: 2.5s ease infinite;
@media only Screen and (max-width: 40em) {
  width: 50vw;
  padding-bottom: 0;
}
`;
const Text = styled.h4`
  font-size: calc(0.5rem + 1vw);
  line-height: 1.5;
  color: var(--nav2);
`;

// const AboutText = styled.div`
//   width: 50%;
//   position: right;
//   @media only Screen and (max-width: 40em) {
//     width: 100%;
//   }
// `;

const About = () => {
  return (
    <AboutSection id="about">
      <Waves src={wave} alt="" />
      <Main>
        {/* <AboutText> */}
          {/* </AboutText> */}
        <Content>
          {/* <Rocket>
            <img src={apii_logo_2} alt="" width="400" height="400" />
          </Rocket>
          <Cloud>
            <img src={logo_3} alt="" width="800" height="400" />
          </Cloud>
            <API>
              <img src={apii_logo} alt="" width="80" height="20" />
            </API>
            <DataChart>
              <img src={logo_1} alt="" width="800" height="400" />
            </DataChart>
           */}
        </Content>
        <Text>
        <div>
          <Title>About Us</Title>
          {/* <CurvedLine /> */}
        </div>
            We're not your average data ops agency. We specialize in crafting bespoke automation solutions that fit like a glove, from ERP, CRM, Data Pipelines to Analytics dashboards and everything in between. We've got all the tools in our arsenal to strengthen your brand's foundation. Ready to level up? Drop us a message along with your contact number using the form below. Let's transform your business together.
        </Text>
      </Main>
    </AboutSection>
  );
};

export default About;
